<template>
    <div class="breathing-light-container">
        <!-- 呼吸灯主体 -->
        <div class="breathing-light breathing"></div>
    </div>
</template>

<script>
export default {
    name: 'BreathingLight',
}
</script>

<style scoped>
.breathing-light-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 4px;
}

.breathing-light {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--light-color, #00ff00);
    box-shadow: 0 0 5px var(--light-color, #00ff00);
    cursor: pointer;
    transition: filter 0.3s;
}

.breathing-light:hover {
    filter: brightness(1.2);
}

.breathing {
    animation: breath var(--breath-duration, 2s) ease-in-out infinite;
}

@keyframes breath {
    0%,
    100% {
        opacity: 0.4;
        transform: scale(0.8);
    }

    50% {
        opacity: 1;
        transform: scale(1.05);
    }
}
</style>